import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import {store} from './store'
import {TokenService} from "./services/token"
import ApiService from "./services/api"

Vue.config.productionTip = false

import VueI18n from "vue-i18n";

Vue.use(VueI18n);
import {languages, defaultLocale} from './i18n/index.js'
const messages = Object.assign(languages);
const dateTimeFormats = {
  'nl': {
    hes: {
      year: '2-digit', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false
    }
  },
  'fr': {
    hes: {
      year: '2-digit', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false
    }
  }
};
const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'nl',
  messages,
  dateTimeFormats
});

//font awesome
import {library} from "@fortawesome/fontawesome-svg-core";
import {
  faChevronRight,
  faChevronLeft,
  faPowerOff,
  faSpinner,
  faArrowCircleLeft,
  faSave,
  faHistory,
  faEdit,
  faInfoCircle,
  faTimes,
  faClone,
  faClock,
  faExclamationTriangle,
  faEuroSign,
  faBan,
  faUserTie,
  faPaperPlane,
  faTrashAlt,
  faArrowCircleUp,
  faArrowCircleDown,
  faPlusCircle,
  faSyncAlt,
  faCog,
  faBars,
  faStar
} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

library.add(
  faChevronLeft,
  faChevronRight,
  faPowerOff,
  faSpinner,
  faArrowCircleLeft,
  faArrowCircleUp,
  faArrowCircleDown,
  faSave,
  faHistory,
  faEdit,
  faInfoCircle,
  faTimes,
  faClone,
  faClock,
  faExclamationTriangle,
  faEuroSign,
  faBan,
  faUserTie,
  faPaperPlane,
  faTrashAlt,
  faPlusCircle,
  faSyncAlt,
  faCog,
  faBars,
  faStar,
  faExclamationTriangle
);
Vue.component('fa-icon', FontAwesomeIcon);


if (TokenService.getToken()) {
  ApiService.setHeader();
  ApiService.mount401Interceptor();
}

// Set the base URL of the API
ApiService.init(process.env.VUE_APP_ROOT_API);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
